export default __webpack_public_path__ + "static/media/honda.30e726e8.svg";